import { jsx as _jsx } from "react/jsx-runtime";
import React, { Children } from 'react';
import styled, { css } from 'styled-components';
import { map } from '../breakpoint';
import { m, mt, p, pl } from '../spacing';
import { isList, isValidSpacing, getSpacingValue, mapColumnstoFlexBasis } from '../utils';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const TilesWrapper = styled(({ as, space, columns, ...rest })=>/*#__PURE__*/ _jsx("div", {
        ...rest
    }))`
  display: flex;
  flex-wrap: wrap;

  /* If set to be a <ul> or <ol> we need to reset the default list styling */
  ${({ as })=>as && isList(as) && css`
      ${m(0)};
      ${p(0)};
      list-style-type: none;
    `}

  /* Negative left and top margins for parent */
  ${({ space })=>map(space, (val)=>isValidSpacing(val) && css`
          margin-block-start: calc(0px - ${getSpacingValue(val)});
          margin-inline-start: calc(0px - ${getSpacingValue(val)});
        `)};

  /* Positive left padding and top margin for child */

  > * {
    box-sizing: border-box;
    min-inline-size: 0;
    width: 100%;

    ${({ space })=>map(space, (val)=>isValidSpacing(val) && css`
            ${mt(val)};
            /* Have to use padding because of box model */
            ${pl(val)};
          `)};

    ${({ columns })=>map(columns, (val)=>val && mapColumnstoFlexBasis(val))};
  }

  /* If grid is supported everything is a lot simpler */
  @supports (display: grid) {
    display: grid;
    ${m(0)};

    > * {
      ${m(0)};
      ${p(0)};
    }

    ${({ space })=>map(space, (val)=>isValidSpacing(val) && css`
            grid-gap: ${getSpacingValue(val)};
          `)};

    ${({ columns })=>map(columns, (val)=>val && css`
            grid-template-columns: repeat(${val}, minmax(0, 1fr));
          `)};
  }
`;
const ChildWrapper = styled.div`
  ${({ flex })=>flex && `
    display: flex;
    width: 100%;
  `};
`;
ChildWrapper.displayName = 'ChildWrapper';
export const Tiles = (props)=>{
    const { children, space = 0, flex = false, ...otherProps } = props;
    const childComponent = isList(props.as) ? 'li' : 'div';
    return /*#__PURE__*/ _jsx(TilesWrapper, {
        "data-mesh-component": "TILES",
        space: space,
        ...otherProps,
        children: Children.map(children, (child)=>{
            if (/*#__PURE__*/ React.isValidElement(child)) {
                return /*#__PURE__*/ _jsx(ChildWrapper, {
                    as: childComponent,
                    flex: flex,
                    children: child
                });
            }
            return null;
        })
    });
};
Tiles.displayName = 'Tiles';

//# sourceMappingURL=index.js.map